module.exports = __webpack_public_path__ + "media/images/badge-7c2ccf6d.svg";